import React from "react";
import { Redirect } from "react-router-dom";

import { graphql, useLazyLoadQuery } from "react-relay";
import GroupCheck from "../../../../GroupCheck";
import ArticleCard from "../../ArticlesList/ArticleCard";
import { ArticleListContainer } from "../../ArticlesList/styles";
import {
  FantasyArticlesCreateButton,
  FantasyArticlesHeader,
  FantasyArticlesTitle,
} from "../../FantasyArticles/styles";
import { isContentWriter, isSiteAdmin } from "../../../../../AuthUtils";

const GET_ARTICLES = graphql`
  query DraftArticlesQuery {
    whoAmI {
      groups {
        name
      }
    }

    draftArticles {
      id
      title
      slug
      endpoint
      imageUrl
      author {
        fullName
      }
      createdOn
    }

    adminDraftArticles {
      id
      title
      slug
      endpoint
      imageUrl
      author {
        fullName
      }
      createdOn
    }
  }
`;

export default function DraftArticles() {
  const data = useLazyLoadQuery(GET_ARTICLES);

  if (!isContentWriter(data.whoAmI.groups)) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <FantasyArticlesHeader>
        <GroupCheck groupName="Content Writer">
          <FantasyArticlesCreateButton href="/article/create">
            New Article
          </FantasyArticlesCreateButton>
        </GroupCheck>
        <FantasyArticlesTitle>Draft Articles</FantasyArticlesTitle>
        <hr />
      </FantasyArticlesHeader>
      <ArticleListContainer>
        {data.draftArticles
          ? data.draftArticles.map((article) => {
              return (
                <ArticleCard
                  article={article}
                  articleLink={article.endpoint}
                  key={article.id}
                  draft={true}
                />
              );
            })
          : null}
      </ArticleListContainer>

      {isSiteAdmin(data.whoAmI.groups) ? (
        <>
          <FantasyArticlesHeader>
            <FantasyArticlesTitle>Team Drafts</FantasyArticlesTitle>
            <hr />
          </FantasyArticlesHeader>
          <ArticleListContainer>
            {data.adminDraftArticles
              ? data.adminDraftArticles.map((article) => {
                  return (
                    <ArticleCard
                      article={article}
                      articleLink={article.endpoint}
                      key={article.id}
                      draft={true}
                    />
                  );
                })
              : null}
          </ArticleListContainer>
        </>
      ) : null}
    </>
  );
}
